angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsAgenda', function (
  $log,
  $timeout,
  TIMING_CONSTANTS,
  URL_VERSIONS,
  LocaleService,
  $q,
  language,
  EventManager,
  PanelFactory,
  TeacherDataService,
  api,
  MapStateService,
  GR78_ASSET_URL,
  C4_ASSET_URL,
  ModuleFilter,
  PlatformService,
  cordovaMessenger
) {
  return {
    templateUrl: 'template.html',
    scope: {
      selectedClass: '='
    },

    link: function (scope, element) {
      TeacherDataService.isTeacherWorkspaceView = true;
      TeacherDataService.inTeacherAgendaView = true;
      scope.$on('$destroy', function() {
        MapStateService.setSelectedResourcesForAgendaCreation({});
        TeacherDataService.isTeacherWorkspaceView = false;
        TeacherDataService.inTeacherAgendaView = false;
      });

      scope.checkModuleAvailable = ModuleFilter.checkAvailable;

      var eventManager = new EventManager('teacherStudentsAgenda', scope);

      scope.isPreview = LocaleService.checkUrlVersion(URL_VERSIONS.Preview);

      scope.getTranslation = function(id){
        return language.get(id);
      }

      scope.moment = moment;

      scope.calendarEvents = [];
      scope.language = language;
      scope.nonItemUpdates ={
        title:false,
        date:false,
        assignee:false,
      }
      scope.confirmation={
        showSendConfirmation:false
      }
      var lastItemImage
      scope.shown_img_index = 0;
      scope.isDragging = false;
      scope.sideAreaRouterList = [];
      scope.selectedSubmod = 0;

      /**********************
          Needed Data
       **********************/
      scope.loadingStatus = {
        done: false,
        failed: false,
        refresh:false
      }
      scope.modules = {
        list: [],
        current: null,
        currentChild: null
      };
      scope.agendas = {
        list: [],
        selected: null
      }
      scope.students = {
        list: [],
        selected: null
      }

      scope.refresh = function(){
        eventManager.broadcast('teacherStudentsAgenda:refresh')
      }

      scope.isMeta = true;
      scope.$watch('modules.current', function(cur_module){
        // $log.log('MODULES>CURRENT : ' , cur_module)
        scope.isMeta = true;
        $timeout(function(){
          if (cur_module){
            scope.isMeta = scope.selectedSubmod > 0 ? false : true;
            scope.selectedSubmod++;
            // $log.log('watching modules current : ',  cur_module, scope.selectedSubmod)
            eventManager.broadcast('module:change:submodule', cur_module.slug);
          }
        }, 100)

      })

      scope.intercept = {};
      scope.$watch('intercept.slug', function(clicked_slug){
        if (clicked_slug){
          scope.modules.list.forEach( function(mod){
            if(mod.slug === clicked_slug){
              scope.modules.current = mod;
            }
          })

        }
      })

      scope.loadReport = function(agenda_unit_id){
        eventManager.broadcast('agenda:to:dashboard', {agenda_unit_id})
      }

      scope.isShowModuleFilterHeader = function(){
        return !((scope.new_agenda.agenda_selected_module.indexOf('run_like_math') > -1) || scope.view_controller.showAgendaImportPanel || scope.view_controller.showCustomUnits || (scope.new_agenda && scope.new_agenda.isCustomUnit))
      }
      scope.$watch('new_agenda.agenda_selected_module', function(val){
        if(!scope.moduleMapData){
          return;
        }
        scope.no_summative = true && val;
        scope.moduleMapData.resources.forEach(function(mod){
          if(mod.slug === scope.new_agenda.agenda_selected_module){
            mod.children.forEach(function(item){
              if(item && item.config && item.config.assessment_type === "summative"){
                scope.no_summative = false;
              }
            })
          }
        })
      })

      scope.addDocListener = function(agenda){
        // $log.log('showing panel')
        agenda.showPanel = true//!agenda.showPanel;
        var func = function(){
          // $timeout(function(){
            // $log.log('hiding panel')
            document.removeEventListener('click', func)
            agenda.showPanel = false;
          // }, 100)
        }
        $timeout(function(){
          if(agenda.showPanel){
            document.addEventListener('click', func)
          }
        },100)
      }
      scope.goToCalendarMode = function(){
        scope.inCalendarMode = true;
        scope.inListMode = false;
      }
      scope.goToListMode = function(){
        scope.inCalendarMode = false;
        scope.inListMode = true;
      }


      /**
       * Side tab router
       * @type {Object}
       */
      scope.sideAreaRouter = {
        current: 'agenda-viewer-map',
        set: function(id, data){
          $log.debug('[[teacherStudentsAgenda]] setting...', id, data)
          this.data = {};
          this.current = id;
          if(data){
            // $log.log('Select New Agenda : ', data)

            if(data.students && !data.is_for_all_class){
              scope.sideAreaRouterList = [];
              data.students.forEach(function(student){
                scope.students.list.forEach(function(cur_student){
                  if(cur_student.user_id === student){
                    scope.sideAreaRouterList.push(cur_student);
                  }
                })
              })
            }else if(data.students && data.is_for_all_class){
              scope.sideAreaRouterList = scope.students.list;
            }

            this.data = data;
          }
        },
        data: {},
        reset: function(){
          this.set('agenda-viewer-map',{})
        },
        reload: function(){
          var id = this.id;
          $log.debug('[[teacherStudentsAgenda]] reloading...', id)
          var sideAreaRouter = this;
          sideAreaRouter.set('agenda-viewer-map', sideAreaRouter.data)
          $timeout(function(){
            sideAreaRouter.set(id, sideAreaRouter.data)
          }, TIMING_CONSTANTS.INSTANT)
        }
      }
      /**
       * Agenda Editor Methods
       * Todo: move to another component
       * @type {Object}
       */
      scope.agendaEditor = {
        creationOpen: false,
        beingEdited: {},
        showItemList: true,
        assign_types: [
          {id: 'class', name: 'Class'},
          {id: 'students', name: 'Student(s)'},
        ],
        reset: function(){
          this.beingEdited = {
            description: '',
            date_open: moment().format('YYYY-MM-DD'),
            date_close: moment().add(1,'weeks').format('YYYY-MM-DD'),
            assign_type: this.assign_types[0]
          }
          this.mods.students.list = {};
          this.mods.resources.reset();
          this.mods.attributes.reset();
        },
        mods: {
          students: {
            getIds: function(){
              return Object.keys(this.list)
            },
            list: {},
            add: function(studentToAdd){
              if(studentToAdd){
                this.list[studentToAdd.user_id] = studentToAdd
              }
            },
            remove: function(studentId){
              if(this.list[studentId]){
                delete this.list[studentId];
              }
            },
            get: function(){
              // $log.log('getting students list:')
              return _.toArray(this.list)
            }
          },
          resources: {
            selectedCustom: {},
            existing: {},
            custom: {},
            list: [],
            initial: [],
            reset: function(){
              this.list = [];
              this.existing = {};
              this.custom = {};
              this.deSelectCustom();
              this.initial = [];
            },
            set: function(resourceRefs) {
              this.reset();
              resourceRefs.forEach(function(resource){
                scope.agendaEditor.mods.resources.add(resource)
              })
              this.initial = this.getIds();
            },
            moveDown: function(resourceId, resourceIndex){
              if(resourceIndex < this.list.length - 1){
               this.list.splice(resourceIndex+1, 0, this.list.splice(resourceIndex, 1)[0]);
              }
            },
            moveUp: function(resourceId, resourceIndex){
              if(resourceIndex > 0) {
               this.list.splice(resourceIndex-1, 0, this.list.splice(resourceIndex, 1)[0]);
              }
            },
            getIds: function(){
              return this.list.map(function(r){ return r.id })
            },
            getCustomDefsMap: function(){
              return this.custom;
            },
            getCustomDefsArray: function(){
              return _.toArray(this.custom)
            },
            add: function(resourceToAdd){
              if(resourceToAdd && !this.existing[resourceToAdd.id]){
                this.list.push(
                  this.existing[resourceToAdd.id] = angular.copy(resourceToAdd)
                )
              }
            },
            contains:function(resourceId){
              var exists = false;
              if(resourceId){
                angular.forEach(this.list,function(each){
                  if(each.id === resourceId){
                    exists = true;
                  }
                });
              }

              return exists;
            },
            remove: function(resourceId){
              if(this.existing[resourceId]){
                this.list = this.list.filter(function(r){
                  return r.id !== resourceId
                })
                if(this.existing[resourceId].deselect) {
                  this.existing[resourceId].deselect()
                }
                delete this.existing[resourceId];
                if(this.custom[resourceId]){
                  delete this.custom[resourceId];
                }
              }
            },
            selectCustom: function(resourceId){
              if(this.custom[resourceId]){
                var customResourceDetails = this.custom[resourceId];
                this.selectedCustom = {
                  value: customResourceDetails.content.value,
                  name: customResourceDetails.name,
                  slug: customResourceDetails.slug,
                  id: customResourceDetails.id,
                  exists: true
                }
              }
            },
            deSelectCustom: function(){
              this.selectedCustom = {
                value: '',
                name: ''
              };
            },
            updateCustom: function(){
              var selectedCustom = this.selectedCustom;
              var id = selectedCustom.id;
              this.custom[id].name = selectedCustom.name;
              this.custom[id].content.value = selectedCustom.value;
              this.existing[id].name = selectedCustom.name;
              this.deSelectCustom()
            },
            addCustom: function(){
              var newCustom = this.selectedCustom;
              var slug = [
                _.toArray(this.custom).length ,
                String(Date.now()) ,
                Math.random().toString(36).substr(3,7)
              ].join('_');
              if(!isValidURL(newCustom.value)) {
                window.alert(scope.getTranslation('27689')) // please enter a valid url
              }else{
                this.list.push(this.existing[slug] = {
                  type: 'custom_resource',
                  name: newCustom.name,
                  id: slug
                })
                this.custom[slug] = {
                  type: 'custom_resource',
                  name: newCustom.name,
                  slug: slug,
                  content: {
                    value: newCustom.value,
                    container: 'link'
                  }
                }
                this.deSelectCustom()
              }
            }
          },
          hideFromStudents: false,
          attributes: {
            reset: function(){
              this.force_unlock.checkboxValue = false;
              this.force_unlock.set(null);
              this.force_redo = false;
              this.attempt_limit = null;
            },
            set: function(agenda){
              this.force_unlock.set(agenda.force_unlock || null);
              this.force_redo = !!agenda.force_redo;
              this.attempt_limit = agenda.attempt_limit || null;
            },
            get: function(){
              return {
                force_unlock: this.force_unlock.get(),
                force_redo: this.force_redo,
                // attempt_limit: this.attempt_limit < 0 ? null : this.attempt_limit,
              }
            },
            force_unlock: {
              value: '0',
              checkBoxValue: true,
              set: function(value){
                if(value === null){
                  this.value = '0';
                  this.checkBoxValue = false;
                } else if (value === false) {
                  this.value = '1';
                  this.checkBoxValue = false;
                } else if (value === true) {
                  this.value = '2';
                  this.checkBoxValue = true;
                } else  {//default to null
                  this.value = '0';
                  this.checkBoxValue = false;
                }
              },
              update: function(){
                if(this.checkboxValue) {
                  this.set(true)
                }else{
                  this.set(null)
                }
              },
              get: function(){
                return this.value === '0' ? null : (
                  this.value === '1' ? false : true
                )
              }
            }
          }
        }
      }

      /**********************
        Agenda Updates/Saves
       **********************/
      scope.createNewAgenda = function(){
        scope.agendaEditor.creationOpen = true;
        scope.agendaEditor.asEdit = false;
        scope.agendas.selected = null;
        scope.agendaEditor.reset();
        scope.sideAreaRouter.reset();
        MapStateService.setSelectedResourcesForAgendaCreation({});
      }
      scope.cancelNewAgenda = function(){
        scope.atItemAddPart = false;
        scope.agendaEditor.creationOpen = false;
        scope.agendaEditor.asEdit = false;
        scope.agendaEditor.reset();
        scope.sideAreaRouter.reset();
        scope.loadingStatus.refresh =true;
        MapStateService.setSelectedResourcesForAgendaCreation({});
        $timeout(function(){
          scope.loadingStatus.refresh =false;
        });
      }
      scope.selectAgenda = function(agenda){
        scope.agendas.selected = angular.copy(agenda);
        scope.agendaEditor.creationOpen = true;
        scope.agendaEditor.asEdit = true;
        scope.agendaEditor.reset();
        scope.sideAreaRouter.reset();
        scope.agendaEditor.beingEdited.description = agenda.description
        scope.agendaEditor.beingEdited.date_open = agenda.date_open
        scope.agendaEditor.mods.attributes.set(agenda);
        scope.agendaEditor.beingEdited.date_close = moment(agenda.date_close).format('YYYY-MM-DD')
        scope.agendaEditor.mods.resources.custom =  angular.copy(agenda.custom_resources);
        scope.agendaEditor.mods.resources.set(agenda.resourceRefs)
        if(agenda.is_for_all_class) {
          scope.agendaEditor.beingEdited.assign_type = scope.agendaEditor.assign_types[0]
        }else{
          scope.agendaEditor.beingEdited.assign_type = scope.agendaEditor.assign_types[1];

          agenda.students.forEach(function(student){
            scope.students.list.forEach(function(cur_student){
              if(cur_student.user_id === student){
                scope.agendaEditor.mods.students.add(cur_student);
              }
            })

          })

          // $log.log('from select: ', scope.students.list)
        }
        MapStateService.setSelectedResourcesForAgendaCreation(scope.agendaEditor.mods.resources);
      }
      scope.getList = function(){
        // $log.log('from get list : ', scope.agendas.selected)
        if(scope.agendas.selected && scope.agendas.selected.is_for_all_class){
          return scope.students.list;
        }else if(scope.agendas.selected){
          return scope.agendaEditor.mods.students;
        }else{
          return [];
        }
      }
      scope.showArchived = false;
      scope.toggleShowArchived = function(){
        scope.showArchived = !scope.showArchived
      }
      scope.archiveAgenda = function(agenda, shouldArchive){
        // $log.log('from archive agenda', agenda)

        var agendaUpdates = {archived:shouldArchive}
        agendaUpdates.published = shouldArchive ? false : true//agenda.published;
        TeacherDataService.updateAgenda(currentClassId, agenda.id, agendaUpdates).then(function(data){
            eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId);
        }).catch(function(err){
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = true;
          $log.error(err);
          window.alert(language.get('agenda_error_update'))
        });
      }
      scope.updateAgenda = function(extraProperties){
        var agendaUpdates = angular.copy(scope.agendaEditor.beingEdited);
        if(extraProperties){
          for(var key in extraProperties){
            agendaUpdates[key] = extraProperties[key];
          }
        }
        agendaUpdates.date_close = moment(agendaUpdates.date_close).hour(23).minute(59).second(59).toDate();
        var agendaMods = scope.agendaEditor.mods;
        var agendaAttributes = scope.agendaEditor.mods.attributes.get();
        var allBad = agendaIsInvalid();
        if(!allBad && !scope.agendaSending) {
          scope.agendaSending = true;
          var original = scope.agendas.selected;
          agendaUpdates.resources = agendaMods.resources.getIds();
          agendaUpdates.custom_resources = agendaMods.resources.getCustomDefsArray();
          var studentIdsInt = [];
          if(agendaUpdates.assign_type.id !== 'class'){
            agendaMods.students.getIds().forEach(function(id){
              studentIdsInt.push(Number(id));
            })
          }
          agendaUpdates.students = studentIdsInt;
          agendaUpdates.force_unlock = agendaAttributes.force_unlock;
          agendaUpdates.published = !agendaMods.hideFromStudents;

          // $log.log('updating agenda : ', agendaUpdates);
          return TeacherDataService.updateAgenda(currentClassId, original.id, agendaUpdates).then(function(data){
            // if(!doNotRefresh){
              eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId);
              // scope.confirmation.showSendConfirmation = false
            // }
          }).catch(function(err){
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            $log.error(err);
            window.alert(language.get('agenda_error_update'))
          });
        }else{
            window.alert(allBad)
        }
      }
      scope.togglePublishAgenda = function(agenda, publish, dontShowConfirmation) {
        var goodTogo = true;
        if(scope.agendaEditor.creationOpen && !dontShowConfirmation) {
          goodTogo = window.confirm("There is some unsaved work, this will be lost if you proceed.\nContinue?")
        }
        if(goodTogo) {
          return TeacherDataService.togglePublishAgenda(currentClassId, agenda.id, !!publish).then(function(){
            eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId)
          }).catch(function(err){
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            $log.error(err);
            window.alert(language.get('agenda_error_publish'))
          })
        }
      }

      scope.deleteAgenda = function(){
        return TeacherDataService.deleteAgenda(currentClassId, scope.agendas.selected.id).then(function(){
          eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId)
        }).catch(function(err){
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = true;
          $log.error(err);
          window.alert(language.get('agenda_error_delete'))
        })
      }
      scope.saveAgenda = function(){
        var agendaInfo = scope.agendaEditor.beingEdited;
        var agendaMods = scope.agendaEditor.mods;
        var allBad = agendaIsInvalid()
        if(!allBad && !scope.agendaSending) {
          scope.agendaEditor.asEdit = false;
          scope.loadingStatus.done = false;
          scope.loadingStatus.failed = false;
          scope.agendaSending =true;
          var studentIdsInt = [];
          if(agendaInfo.assign_type.id !== 'class'){
            agendaMods.students.getIds().forEach(function(id){
              studentIdsInt.push(Number(id));
            })
          }

          TeacherDataService.createAgenda(
              currentClassId,
              agendaMods.resources.getIds(),
              agendaInfo.description,
              agendaInfo.date_close,
              agendaInfo.date_open,
              agendaMods.resources.getCustomDefsMap(),
              studentIdsInt,
              scope.modules.current.id,
              agendaMods.attributes.get(),
              agendaMods.hideFromStudents
          ).then(function(){
            eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId)
          }).catch(function(err){
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            $log.error(err);
            window.alert(language.get('agenda_error_save'))
          })
        }else{
          window.alert(allBad)
        }
      }
      scope.saveAndPublishAgenda = function(){
        var agendaInfo = scope.agendaEditor.beingEdited;
        var agendaMods = scope.agendaEditor.mods;
        var allBad = agendaIsInvalid()
        if(!allBad && !scope.agendaSending) {
          scope.agendaEditor.asEdit = false;
          scope.loadingStatus.done = false;
          scope.loadingStatus.failed = false;
          scope.agendaSending = true;
          if(agendaMods.hideFromStudents === null){
            // $log.log('returning')
            return;
          }
          TeacherDataService.createAgenda(
              currentClassId,
              agendaMods.resources.getIds(),
              agendaInfo.description,
              agendaInfo.date_close,
              agendaInfo.date_open,
              agendaMods.resources.getCustomDefsMap(),
              agendaInfo.assign_type.id === 'class' ? [] : agendaMods.students.getIds(),
              scope.modules.current.id,
              agendaMods.attributes.get(),
              agendaMods.hideFromStudents
          ).then(function(agenda){
            // scope.togglePublishAgenda(agenda,true,true).then(function(data){
            //   $log.log(data);
              $timeout(function(){
                scope.agendaSending = false;
                scope.confirmation.showSendConfirmation = false;
                eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId)
              },100);
            // });
          }).catch(function(err){
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            // scope.agendaSending = false;
            $log.error(err);
            window.alert(language.get('agenda_error_save'))
          })
        }else{
          window.alert(allBad)
        }
      }

      scope.onSendToStudents = function(agenda){
        if(!scope.agendas.selected){
          scope.saveAndPublishAgenda();
        }else if(scope.agendas.selected){
          scope.updateAgenda({published:true});
        }
      }

      scope.onSaveDraftClicked = function(){
        if(scope.agendas.selected){
          scope.updateAgenda();
        }else{
          scope.saveAgenda();
        }
      }

      scope.getResourceName = function(resource){
        return resource.resource_type === 'custom_resource' ? resource.name : language.get(resource.slug)||resource.name
      }

      scope.studentSelections = {allSelected:true}
      var timeout_selection = false;
      scope.$watch('studentSelections.allSelected', function(val){
        if(timeout_selection){
          return;
        }
        scope.students.list.forEach(function(student){
          student.selected = val;
        })
        scope.agenda_calendar.refreshCalendar = !scope.agenda_calendar.refreshCalendar;
      })
      scope.refreshStudentFilter = function(){
        var found_unselected = false;
        scope.students.list.forEach(function(std){
          if(!std.selected){
            found_unselected = true;
          }
        })
        timeout_selection = true;
        scope.studentSelections.allSelected = !found_unselected;
        $timeout(function(){
          timeout_selection = false;
        }, 100)
        scope.agenda_calendar.refreshCalendar = !scope.agenda_calendar.refreshCalendar;
      }

      scope.selectResource = function(resource, bubbleModuleItem, dontSelectList) {
          if(bubbleModuleItem) {
            var force = dontSelectList ? dontSelectList.state : null;
            // $log.log('from agenda select resource!', scope.view_controller.highlightedItem, dontSelectList)
            if(scope.view_controller.highlightedItem && dontSelectList && !dontSelectList.dontSelect){
              eventManager.broadcast('hide_item_selection_highlight', scope.view_controller.highlightedItem)
            }
            bubbleModuleItem.showAgendaHighlight(force, dontSelectList && (dontSelectList.highlightItem || !dontSelectList.dontSelect));
          }

          if(scope.agendaEditor.mods.resources.contains(resource.id) && (!dontSelectList || dontSelectList.state === false)){
            scope.agendaEditor.mods.resources.remove(resource.id);
          }else if(!dontSelectList || dontSelectList.state){
            scope.agendaEditor.mods.resources.add(angular.extend(resource, {
              deselect: bubbleModuleItem ? bubbleModuleItem.showAgendaHighlight : null
            }));
          }


          // $log.log('SELECT RESOURCE : ', scope.agendaEditor.mods.resources,bubbleModuleItem, dontSelectList)


          if(dontSelectList && dontSelectList.dontSelect){
            return;
          }
          scope.view_controller.selectItemBySlug(resource.slug, scope.agendaEditor.mods.resources.contains(resource.id), true);
          MapStateService.setSelectedResourcesForAgendaCreation(scope.agendaEditor.mods.resources);
      }
      /**********************
              Generic
       **********************/
      var isValidURL = function(str) {
        var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
        var regex = new RegExp(expression);
        if(!str) {
          return false;
        }else{
          return str.match(regex);
        }
      }
      var agendaIsInvalid = function(){
        var agenda = scope.agendaEditor.beingEdited;
        if(!agenda.description) {
          return language.get('22946');//'Please enter a valid agenda description.';
        }else if(moment(agenda.date_close).hour(23).minute(59).second(59) < moment.now()){
          return language.get('22950')//'The date that you selected has passed. Please select a future date.';
        }
        else if(!scope.agendaEditor.mods.resources.list || scope.agendaEditor.mods.resources.list.length===0){
          return language.get('22947');//'Please assign items.';
        }else if(scope.agendaEditor.beingEdited.assign_type.id === 'students' && scope.agendaEditor.mods.students.get().length === 0 ){
          return language.get('agenda_empty_student_list');
        }
        else  {
          return false;
        }
      }
      var formatTime = function(time){
        var mm = moment(time);
        return [mm.format('YYYY-MM-DD'), 'at', mm.format('ha z')].join(' ');//the default timezone is set at src/index.module.js
      }
      var resourceIsCustom = function(resource) {
        return resource.resource_type === 'custom_resource';
      }
      scope.formatTime = formatTime;
      scope.resourceIsCustom = resourceIsCustom;
      scope.getDay = function(date){
        return moment(date).format('DD');
      }
      scope.getMonth = function(date){
        return moment(date).format('MMM').toUpperCase()
      }

      var getEventDisplay = function(openDate,CloseDate,isPublished){
        var color = "green";
        var now = moment();
        if(now.diff(CloseDate)<0 && isPublished){
          color = "green";
        }else if(now.diff(CloseDate)>0 && isPublished){
          color = "gray";
        }else{
          color = "red";
        }

        return {
          color:color
        }
      }

      var updateCalendarEvents = function(agendas){
        var events = [];
        angular.forEach(agendas,function(agenda){
          var eventOpenDate = (moment(agenda.date_open));
          var eventCloseDate = (moment(agenda.date_close));
          var display = getEventDisplay(eventOpenDate,eventCloseDate,agenda.published);
          var eventMonth = {
            display:display,
            eventDate:eventCloseDate,
            description:agenda.description,
            onClick:function(agenda){
              if(agenda.published)
              {
                scope.sideAreaRouter.set('agenda-info',agenda);
              }else{
                scope.selectAgenda(agenda);
              }
            },
            onClickParams:agenda
          }
          events.push(eventMonth);
        });

        scope.calendarEvents = events;
        eventManager.broadcast("calendarEvents:updated",events);
      }


      /**********************
              Watchers
       **********************/
      var currentClassId;


      scope.inListMode = false;
      scope.toCreationMode = function(){
        scope.inCreateListMode = true;
      }
      scope.hasAgendaStarted = function(date){
        return Date.now() < Date.parse(date);
      }
      scope.getFormattedDate = function(date){
        var formatted = date.split('T')[0].split('-');
        return formatted[2]+'';
      }
      var dayRef = ['SUN','MON','TUE','WED','THU','FRI','SAT']
      scope.getFormattedDateDay = function(date){
        var day = (new Date(Date.parse(date))).getDay()
        return dayRef[day]
      }
      var monthRef = ['January','February','March','April','May','June','July',
      'August','September','October','November','December']
      scope.getFormattedDateMonth = function(date){
        var formatted = date.split('T')[0].split('-');
        return formatted[0]+' '+monthRef[Number(formatted[1])-1];
      }
      scope.isFirstShown = function(agenda_index){
        if(agenda_index === 0){
          return true;
        }
        return scope.getFormattedDateMonth(scope.agendas.list[agenda_index].date_open) !== scope.getFormattedDateMonth(scope.agendas.list[agenda_index-1].date_open)
      }
      function dateSort(a,b){
        if (Date.parse(a.date_open) < Date.parse(b.date_open)){
          return 1;
        }
        if (Date.parse(a.date_open) > Date.parse(b.date_open)){
          return -1;
        }
        return 0;
      }

      scope.panelDisplay = {
        slug: 'c4_m2',
        isExpanded: false,
        sub: {}
      };

      eventManager.listen('teacherStudentsAgenda:refresh', function(e, selectNewest){
        scope.loadingStatus.done = false;
        scope.loadingStatus.failed = false;
        return TeacherDataService.getClassAgendas(currentClassId, true)
        .then(function(agendas){
          // $log.log('from agenda refresh : ', agendas)
          scope.agendas.list = agendas
          scope.agendas.list.sort(dateSort);
          updateCalendarEvents(scope.agendas.list);
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = false;
          scope.agendaEditor.creationOpen = false;
          scope.agendaEditor.asEdit = false;
          scope.atItemAddPart = false;
          // scope.agendaEditor.reset();
          // scope.sideAreaRouter.reset();

          scope.loadingStatus.refresh = true;
          createCustomUnitsList();
          if(selectNewest === true){
            var newest_id = _.max(_.map(scope.agendas.list, 'id'));
            var newest = _.find(scope.agendas.list, function(a){return a.id === newest_id})
            scope.agenda_calendar.currentAgenda = newest;
            scope.agenda_calendar.editCurrentAgenda(true);
            scope.new_agenda.move_page(1);
          }
          $timeout(function(){
            scope.confirmation.showSendConfirmation = false;
            scope.loadingStatus.refresh = false;
            scope.agendaSending = false;
          });
        }).catch(function(error){
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = true;
          scope.sideAreaRouter.reload();
          $log.error(error);
        })
      })

      function displayOrderSort(a,b) {
        if(!a.display || !b.display ){
          return 0;
        }
        if (a.display.order < b.display.order){
            return -1;
        }
        if (a.display.order > b.display.order){
            return 1;
        }
        return 0;
      }

      function createCustomUnitsList(){
        scope.custom_units_list = [];
        scope.all_custom_units_list = []
        scope.agendas.list.forEach(function(agenda){
          var is_custom = true
          scope.moduleMapData.resources.forEach(function(mod){
            if(mod.slug === agenda.description){
              is_custom = false;
            }
          })
          if(is_custom && !agenda.archived){
            scope.all_custom_units_list.push(agenda)
          }
        })
        _.forEach(scope.all_custom_units_list, function(el){
          var is_duplicate = false;
          scope.custom_units_list.forEach(function(unit){
            is_duplicate = is_duplicate || (arraysEqual(unit.resources, el.resources) && el.description === unit.description)
          })
          if(!is_duplicate){
            scope.custom_units_list.push(el);
          }
        })
      }
      function arraysEqual(arr1, arr2) {
        if(arr1.length !== arr2.length){
          return false;
        }
        for(var i = arr1.length; i--;) {
          if(arr1[i] !== arr2[i]){
            return false;
          }
        }

        return true;
      }

      eventManager.listen('teacherStudentsAgenda:init', function(e,class_id){
        scope.loadingStatus.done = false;
        scope.loadingStatus.failed = false;
        scope.agendaEditor.creationOpen = false;
        scope.agendaEditor.reset();
        scope.sideAreaRouter.reset();
        scope.resetAgendaModalState();
        currentClassId=class_id;
        scope.currentClassId = class_id;
        $timeout(function(){
          $q.all([
            TeacherDataService.getClassFullModulesStructured(class_id).then(function(moduleListFlat){
              moduleListFlat.resources = moduleListFlat.resources.sort(displayOrderSort)
              // $log.log('moduleListFlat : ', moduleListFlat)
              scope.moduleMapData = moduleListFlat;
              scope.asset_url = scope.moduleMapData.resources && scope.moduleMapData.resources[0].parent_resource_id === 99 ? GR78_ASSET_URL : C4_ASSET_URL;

              scope.modules.list = moduleListFlat.resources;
              scope.modules.current = scope.modules.list[0];
              scope.itemsNameList = [];
              scope.rlmFilteredList = [];
              scope.modules.list.forEach(function(mod){
                //filtering out c3 rlm modules
                if(mod.parent_resource_id !== 192 && ModuleFilter.checkAvailable(mod) && mod.id !== 192){
                  scope.rlmFilteredList.push(mod);
                }
                mod.children.forEach(function(lesson){
                  if (lesson){
                    var name = language.get(lesson.slug);
                    if(name !== lesson.slug){
                      scope.itemsNameList.push({slug:lesson.slug, name:language.get(lesson.slug), id:lesson.id});
                    }
                  }
                })
              })
              // $log.log('list : ', scope.itemsNameList)
            }),
            TeacherDataService.getClassStudents(class_id, null, true, false).then(function(currentStudents){
              // $log.log('from get class students: ', currentStudents)
              scope.students.list = currentStudents;
              scope.students.list.forEach(function(student){
                student.selected = true;
              })
              // $log.log('from init: ', scope.students.list)
            }),
            TeacherDataService.getClassAgendas(class_id, true).then(function(agendas){
              // $log.log('from agenda init : ', agendas)
              scope.agendas.list = agendas;
              scope.agendas.list.sort(dateSort);
              updateCalendarEvents(scope.agendas.list);
              createCustomUnitsList();
            })
          ]).then(function(){
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = false;
          }).catch(function(err){
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            $log.error(err);
            //window.alert('Something went wrong, failed to delete Agenda')
          })
        }, 500)

      })

      /**********************
            INIT
      **********************/
      TeacherDataService.getUserClasses().then(function(classes){
        scope.classes = classes;
        scope.$watch('selectedClass', function(classroom){
          if (classroom){
            // $log.log('selectedClass : ', classroom)
            eventManager.broadcast('teacherStudentsAgenda:init', classroom.id);
            scope.resetAgendaModalState();
            scope.view_controller.reset();
          }
        });
      });

      scope.displaySelectedStudents = function(option){
        return [option.info.first_name,option.info.last_name].join(' ')
      }

      scope.displayModule = function(option){
        return language.get(option.slug);
      }

      scope.addSummativeToAgenda = function(){
        scope.moduleMapData.resources.forEach( function(resc){
          if(resc.id === scope.modules.current.id){
            resc.children.forEach( function(child){
              if(child.slug.indexOf('summative') > -1){
                scope.agendaEditor.mods.resources.add(child);
              }
            })
          }
        })
      }

      scope.atItemAddPart = false;
      scope.getAgendaBgClass = function(){
        if(scope.agendaEditor.creationOpen && !scope.atItemAddPart){
          return 'agenda-bg-grey';
        }else if(scope.atItemAddPart){
          return 'agenda-bg-light-grey';
        }else {
          return 'agenda-bg-white';
        }
      }

      scope.itemAddPartToggle = function(bool){
        if(bool === false){
          scope.atItemAddPart = false;
        }else{
          scope.atItemAddPart = true;
        }
      }

      scope.filteredNameList = [];
      scope.itemSearchChange = function(val){
        scope.filteredNameList = [];
        if(!scope.itemsNameList){
          return;
        }
        if(val.trim() !== ''){
          scope.filteredNameList = scope.itemsNameList.filter(function(name){
            var nameMod = name.name.toLowerCase();
            var valMod = val.toLowerCase();
            var bool_val;
            try{
              bool_val = nameMod.match(valMod)
            }catch(e){
              bool_val = false
            }
            return bool_val;
          })
        }
        // $log.log('scope.filteredNameList', scope.filteredNameList);
      }

      eventManager.listen('language:change', function(){
        scope.itemsNameList = [];
        scope.modules.list.forEach(function(module){
          module.children.forEach(function(lesson){
            var name = language.get(lesson.slug);
            if(name !== lesson.slug){
              scope.itemsNameList.push({slug:lesson.slug, name:language.get(lesson.slug), id:lesson.id});
            }
          })
        })
      })

      eventManager.listen('calendar:date:selected',function(e,date){
        if(date && !scope.agendaEditor.creationOpen){
          scope.createNewAgenda();
          scope.agendaEditor.beingEdited.date_close = date.format("YYYY-MM-DD");
        }
        else if(date && scope.agendaEditor.creationOpen){
          scope.agendaEditor.beingEdited.date_close = date.format("YYYY-MM-DD");
          scope.nonItemUpdates.date = false;
          dateChanged();
        }

      });

      scope.initializeAgendaCreationDisplay = function(){
        scope.atItemAddPart = true;
        $timeout(function(){
          if(scope.agendaEditor.asEdit){
            if(!scope.agendas.selected.description){
              scope.nonItemUpdates.title = true;
            }
          }else{
            scope.nonItemUpdates.title = true;
            scope.nonItemUpdates.date = true;
            scope.nonItemUpdates.assignee = true;
          }
        },50);
        $timeout(function(){
          if(scope.agendaEditor.asEdit){
            if(!scope.agendas.selected.description){
              document.getElementById("agenda-title").focus();
            }
          }else{
            document.getElementById("agenda-date").focus();
          }
        },100);
      }

      scope.onDateFocused = function(){
        scope.nonItemUpdates.date = true;
        $timeout(function(){
          document.getElementById("agenda-date").focus();
        },50);
      }

      var dateChanged = function(){
        if(scope.nonItemUpdates.title){
          $timeout(function(){
            document.getElementById("agenda-title").focus();
          },50);
        }
      }

      document.onclick =function() {
        $timeout(function(){
          if(scope.atItemAddPart && (scope.nonItemUpdates.title || scope.nonItemUpdates.date || scope.nonItemUpdates.assignee)){
            scope.nonItemUpdates = {};
          }
        });
      };

      scope.getAgendaBgColor = function(agenda){
        if(!agenda.published){
          return 'agenda-bg-red';
        }else if(moment(agenda.date_close) < moment.now()){
          return 'agenda-bg-grey';
        }else{
          return 'agenda-bg-green';
        }
      }

      scope.scrollToOptions = function(visibility){
        if(visibility){
          $timeout(function(){
            document.getElementById('agendaItemsOption').scrollIntoView()
          },50);
        }
      }

      scope.$watch('agendaEditor.beingEdited.date_close',function(val){
        scope.nonItemUpdates.date = false;
        if(val && scope.agendaEditor.creationOpen && scope.nonItemUpdates.title){
          dateChanged();
        }
      })





      //NEW STUFF
      scope.new_agenda = {
        unlock_path: true,
        description: '',
        unitResourcesList: [],
        isCustomUnit: false,
        showAgendaModule: false,
        confirmWizardClose: false,
        selectImportAgenda: function(){
          scope.view_controller.showAgendaImportPanel = true;
        },
        agenda_pages: [
          {
            page:'module_selection_page',
            header: '27502' // select your topic
          },
          {
            page:'date_selection_page',
            header: '27491' //when
          },
          {
            page:'student_selection_page',
            header: '27672' // who?
          }
        ],
        cur_index: 0,
        agenda_current_page: {
          page:'module_selection_page',
          header: '27502' // select your topic
        },
        module_checkbox_selections: {
          diagnostic: true,
          formative: true,
          summative: false
        },
        agenda_selected_module: '',
        move_page: function(index){
          // if(scope.new_agenda.get_button_state(index).indexOf('disabled') > -1){
          //   return;
          // }
          var new_index = scope.new_agenda.cur_index + index;
          if(new_index > -1 && new_index < scope.new_agenda.agenda_pages.length){
            scope.new_agenda.agenda_current_page = scope.new_agenda.agenda_pages[new_index];
            scope.new_agenda.cur_index = new_index
            // if(scope.new_agenda.editAgendaId && scope.new_agenda.inEditMode){
            //   createNewAgendaV2(true);
            // }
          }else if(new_index >= scope.new_agenda.agenda_pages.length){
            scope.new_agenda.showAgendaModule = false;
            createNewAgendaV2();
          }
        },
        get_button_state: function(continue_btn){
          if(continue_btn){
            if(scope.new_agenda.cur_index < scope.new_agenda.agenda_pages.length && (scope.new_agenda.isCustomUnit || scope.new_agenda.agenda_selected_module !== '')){
              return 'agenda_footer_buttons_enabled';
            }else{
              return 'agenda_footer_buttons_disabled';
            }
          }else{
            if(scope.new_agenda.cur_index > 0){
              return 'agenda_footer_buttons_enabled';
            }else{
              return 'agenda_footer_buttons_disabled';
            }
          }
        },
        reset: function(){
          scope.new_agenda = {};
          scope.new_agenda = angular.copy(new_agenda_default);
        },
        newAgendaFromToday: function(){
          scope.resetAgendaModalState();
          scope.new_agenda.showAgendaModule = true
        }
      }
      var new_agenda_default = angular.copy(scope.new_agenda);

      function getConvertedDate(date, isStart){
        var diff = 1//isStart ? 0 : 1;
        var start_date = new Date();
        // $log.log('start_date MONTH 0', start_date.getMonth(), date)
        start_date.setDate(1);
        start_date.setMonth(start_date.getMonth()+date.page);
        // $log.log('start_date MONTH 1', start_date.getMonth())
        var mth_arr = constructMonthArrays(start_date.getMonth(), start_date.getFullYear());
        start_date.setDate(Number(mth_arr[date.month_row*7+date.day]+diff));
        // $log.log('start_date MONTH 2', start_date.getMonth())
        var moment_date;
        if(isStart){
          moment_date = new moment(start_date).hour(0).minute(0).second(0).toDate();
        } else{
          moment_date = new moment(start_date).hour(23).minute(59).second(59).toDate();
        }
        // $log.log('start_date MONTH 3', start_date.getMonth())
        // $log.log('converted date : ' , start_date, moment_date);
        return moment_date;
      }

      function createNewAgendaV2(dontRefresh){
        var resources = [];
        var students = [];
        var mod_id;
        var description = '';
        if(scope.new_agenda.isCustomUnit){
          resources = scope.new_agenda.unitResourcesList;
          description = scope.new_agenda.description;
          mod_id =scope.modules.current.parent_resource_id;
        }else{
          description = scope.new_agenda.agenda_selected_module;

          scope.moduleMapData.resources.forEach(function(mod){
            if(mod.slug === scope.new_agenda.agenda_selected_module){
              mod.children.forEach(function(item){
                if (item){
                  // $log.log('adding item : ' , item)
                  if(item.config && item.config.assessment_type === "diagnostic"){
                    if(scope.new_agenda.module_checkbox_selections.diagnostic){
                      resources.push(item.id);
                    }
                  }else if(item.config && item.config.assessment_type === "summative"){
                    if(scope.new_agenda.module_checkbox_selections.summative){
                      resources.push(item.id);
                    }
                  }else if(scope.new_agenda.module_checkbox_selections.formative && (item.resource_type === "lesson" || item.config.assessment_type === "formative")){
                    resources.push(item.id);
                  }
                }
              })
              mod_id = mod.id;
            }
          })
        }

        if(resources.length === 0){
          window.alert(language.get('22947'));
          return;
        }

        var is_whole_class = true;
        scope.students.list.forEach(function(student){
          if(student.selected){
            students.push(student.user_id);
          }else{
            is_whole_class = false;
          }
        })

        if(is_whole_class){
          students = [];
        }

        var start_date = getConvertedDate(scope.agenda_calendar.selectionDates.startDate, true)
        var end_date = getConvertedDate(scope.agenda_calendar.selectionDates.endDate)

        var custom_resources = {};
        scope.custom_module_controller.list.forEach(function(resource){
          custom_resources[resource.slug] = {
            type: 'custom_resource',
            name: resource.name,
            slug: resource.slug,
            content: resource.content
          }
          custom_resources[resource.slug].content.position_data = {
            parent_slug: resource.parent_slug,
            index: resource.item_index
          }
          if(resource.id){
            custom_resources[resource.slug].id = resource.id;
          }
        })

        if(scope.new_agenda.editAgendaId && scope.new_agenda.inEditMode){
          var custom_arr = [];
          for(var key in custom_resources){
            custom_arr.push(custom_resources[key])
          }
          var agendaUpdates = {
            description: description,
            date_close:end_date,
            date_open:start_date,
            resources:resources,
            students:students,
            custom_resources:custom_arr,
            force_unlock:scope.new_agenda.unlock_path,
            force_redo: scope.agenda_student_selection.forceReattempt
          }

          // $log.log('updating agenda : ', currentClassId, scope.new_agenda.editAgendaId, agendaUpdates);
          return TeacherDataService.updateAgenda(currentClassId, scope.new_agenda.editAgendaId, agendaUpdates).then(function(data){

            eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId);
            if(!dontRefresh){
                scope.resetAgendaModalState(true);
              }
          }).catch(function(err){
            if(!dontRefresh){
              scope.resetAgendaModalState(true);
            }
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            $log.error(err);
            window.alert(language.get('agenda_error_update'))
          });
        }else{
          TeacherDataService.createAgenda(
            currentClassId,
            resources,
            description,
            end_date,
            start_date,
            custom_resources,
            students,
            mod_id,
            {
              force_unlock: scope.new_agenda.unlock_path,
              force_redo: scope.agenda_student_selection.forceReattempt,
            },
            false
          ).then(function(){
            eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId)
            if(!dontRefresh){
              scope.resetAgendaModalState(true);
            }
          }).catch(function(err){
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            if(!dontRefresh){
              scope.resetAgendaModalState(true);
            }
            $log.error(err);
            window.alert(language.get('agenda_error_save'))
          })
        }


        // scope.resetAgendaModalState();
      }

      scope.resetAgendaView = function(){
        eventManager.broadcast('refresh:current:tab')
      }

      scope.resetAgendaModalState = function(reset_students){
        scope.new_agenda.reset();
        scope.agenda_student_selection.reset();
        scope.agenda_calendar.reset();
        scope.custom_module_controller.reset();
        scope.view_controller.showAgendaImportPanel = false;

        scope.agenda_calendar.selectionDates.settingEndDate = false;

        current_date = new Date();
        var date_diff = getDateDiff(current_date);
        scope.agenda_calendar.setDateSelection(date_diff, current_date.getDay(), true, current_date.getMonth());
        var date_plus_one_week = new Date();
        date_plus_one_week.setDate(date_plus_one_week.getDate()+7);
        var date_diff2 = getDateDiff(date_plus_one_week);
        scope.agenda_calendar.setDateSelection(date_diff2, date_plus_one_week.getDay(), current_date.getMonth() === date_plus_one_week.getMonth(), date_plus_one_week.getMonth());

        if(reset_students){
          scope.students.list.forEach(function(student){
            student.selected = true;
          })
        }
      }

      var current_date = new Date();
      scope.toggleAgendaModule = function(val){
        scope.new_agenda.showAgendaModule = val;
        if(!val){
          scope.resetAgendaModalState(true);
          scope.show_close_warning = false;
          if(scope.agenda_nav_move){
            scope.agenda_nav_move = false;
            if(scope.saved_nav_option.class_change){
              eventManager.broadcast('agenda_class_change_request_granted', scope.saved_nav_option.class_id);
            }else if(scope.saved_nav_option.goto_myclass){
              eventManager.broadcast('agenda_myclasses_change_request_granted', null);
            }else{
              eventManager.broadcast('agenda_change_request_granted', scope.saved_nav_option);
            }
          }
          scope.saved_nav_option = '';
        }
      }
      var months_range=[31,28,31,30,31,30,31,31,30,31,30,31];
      // var date_arr = [];
      function constructMonthArrays(month, year){
        //var current_date = new Date();
        // for(var i = current_date.getMonth();i<12+current_date.getMonth();i++){
        var date_checker = new Date();
        date_checker.setFullYear(year);
        date_checker.setDate(1);
        date_checker.setMonth(month);

        month = month + 1;
        var month_arr = [];
        var totalDays = 1 + (2*month) + parseInt(3*(month+1)/5) + year + parseInt(year/4) - parseInt(year/100) + parseInt(year/400) + 2;
        var dayNo = date_checker.getDay();//(totalDays%7)-1;
        var monthDays = months_range[month-1];
        if((year/4)%1 === 0 && monthDays === 28){
          monthDays = 29;
        }
        if(dayNo === -1){
          dayNo = 6;
        }

        for(var k = 0; k < dayNo; k++){
          month_arr.push('')
        }
        for(var h = 0; h < monthDays; h++){
          month_arr.push(h)
        }
        for(var w = month_arr.length; w < Math.max(35,monthDays+dayNo); w++){
          month_arr.push('')
        }

        // $log.log('CONSTRUCT MONTH ARRAY   : ',month, year, month_arr)
        // $log.log('date_arr : ', month_arr, year+'/'+month, monthDays, dayNo);
        return month_arr;

      }

      function getDateVal(year, month, day, start){
        var checked_date_value = new Date(Number(year), Number(month),Number(day+1));
        if(start){
          checked_date_value.setHours(0, 0, 1);
        }else{
          checked_date_value.setHours(23, 59, 59);
        }
        return checked_date_value
      }
      function isSameDate(date1, date2){
        return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
      }

      scope.returnMonthAndYear = (month, year, abbr) => {
        let thisDate = new Date(year, month);
        return moment(thisDate).format(`${abbr ? 'MMM' : 'MMMM'} YYYY`)
      }

      scope.getCalenderDisplayMonthAndYear = (month, year, abbr) => {
        // console.log("before ", thisDate)
        // console.log(moment(thisDate).format(`MMM YYYY`))

        // let thisDate = new Date(year, month);

        // console.log("after ", thisDate, month)
        // console.log(moment(thisDate).format(`MMM YYYY`))
        return moment(current_date).format(`${abbr ? 'MMM' : 'MMMM'} YYYY`)
      }
      scope.lastModuleType = "initial";
      scope.month_array = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      scope.agenda_calendar = {
        reset: function(){
          // $log.log('FROM RESET', scope.agenda_calendar.pageCounter)
          //var counter_copy = scope.agenda_calendar.pageCounter;
          scope.agenda_calendar.focusOnDate(false, true);
          scope.agenda_calendar = {};
          scope.agenda_calendar = angular.copy(agenda_calendar_default);
          // scope.agenda_calendar.pageCounter = 0//counter_copy;
        },
        pageCounter: 0,
        currentMonth: current_date.getMonth(),
        currentYear: current_date.getFullYear(),
        nextYear: current_date.getMonth() === 11 ? current_date.getFullYear() + 1 : current_date.getFullYear(),
        currentMonthArray: constructMonthArrays(current_date.getMonth(), current_date.getFullYear()),
        nextMonthArray: constructMonthArrays((current_date.getMonth()+1)%12, current_date.getMonth() === 11 ? current_date.getFullYear()+1:current_date.getFullYear()),
        getDaysRow: function(index, isNext){
          var arr = [];
          var month_indx = isNext ?scope.agenda_calendar.nextMonthArray : scope.agenda_calendar.currentMonthArray;
          for(var i = 0; i < 7; i++){
            var val = month_indx[i+index*7];
            if( month_indx[i+index*7] === undefined ||  month_indx[i+index*7] === null){
              val = "";
            }else if(val !== ""){
              val++;
            }
            arr.push(val);
          }
          // $log.log('returning rows: ', arr)
          return arr;
        },
        shiftMonths: function(dir, allowPrevious){
          if(scope.agenda_calendar.pageCounter + dir < 0 && !allowPrevious){
            return;
          }
          scope.agenda_calendar.currentMonth = scope.agenda_calendar.currentMonth+dir;
          if(scope.agenda_calendar.currentMonth === -1){
            current_date.setFullYear(current_date.getFullYear()-1);
            current_date.setDate(1);
            current_date.setMonth(11);
            scope.agenda_calendar.currentMonth = 11;
          }else if(scope.agenda_calendar.currentMonth === 12){
            current_date.setFullYear(current_date.getFullYear()+1);
            current_date.setDate(1);
            current_date.setMonth(0);
            scope.agenda_calendar.currentMonth = 0;
          }else{
            current_date.setDate(1);
            current_date.setMonth(scope.agenda_calendar.currentMonth);
          }
          scope.agenda_calendar.pageCounter += dir;
          scope.agenda_calendar.currentYear = current_date.getFullYear();
          scope.agenda_calendar.nextYear = current_date.getMonth() === 11 ? current_date.getFullYear() + 1 : current_date.getFullYear();
          scope.agenda_calendar.currentMonthArray = constructMonthArrays(current_date.getMonth(), current_date.getFullYear());
          scope.agenda_calendar.nextMonthArray = constructMonthArrays((current_date.getMonth()+1)%12, current_date.getMonth() === 11 ? current_date.getFullYear()+1:current_date.getFullYear());

          // $log.log('SHIFT : ' , scope.agenda_calendar, current_date.getMonth()+'/'+current_date.getFullYear())
          scope.$broadcast('calendar-month-change')
        },
        selectionDates: {
          startDate: {
            page:0,
            month_row:null,
            day:null,
          },
          endDate: {
            page:0,
            month_row:null,
            day:null,
          },
          settingEndDate: false
        },
        setDateSelection: function(month_row, day, isCurrent, month_value, fromClick, full_year){
          // $log.log('set date selection : ' , month_row, day, isCurrent, month_value, fromClick, full_year, scope.agenda_calendar.currentYear)
          if(!month_value && month_value !== 0){
            month_value = isCurrent ? scope.agenda_calendar.currentMonth : scope.agenda_calendar.currentMonth+1;
          }
          var year_to_use = full_year || scope.agenda_calendar.currentYear;
          if(!full_year && (month_value === 12 || (scope.agenda_calendar.currentMonth === 11 && !isCurrent))){
            year_to_use++;
            month_value = 0;
          }
          var arr_to_check = constructMonthArrays(month_value, year_to_use)//isCurrent ? scope.agenda_calendar.currentMonthArray : scope.agenda_calendar.nextMonthArray;
          // $log.log('setting selection date : ' , month_row, day,month_value,year_to_use, isCurrent, scope.agenda_calendar.selectionDates.settingEndDate, arr_to_check[month_row*7+day])
          if((!arr_to_check[month_row*7+day] && arr_to_check[month_row*7+day] !== 0) || arr_to_check[month_row*7+day] === ""){
            return;
          }
          var start = scope.agenda_calendar.selectionDates.startDate;
          var end = scope.agenda_calendar.selectionDates.endDate;
          var start_date_value;
          var end_date_value;

          var year_diff = year_to_use - new Date().getFullYear();

          var checked_date_value = getDateVal(year_to_use , month_value, Number(arr_to_check[month_row*7+day]), false);
          // $log.log('comparison : ',year_to_use, scope.agenda_calendar.currentYear, arr_to_check, month_row, day, checked_date_value, getTodayDateConverted())
          if(checked_date_value < getTodayDateConverted() && (!scope.new_agenda.inEditMode || fromClick)){
            return;
          }

          var today_month = new Date().getMonth();
          if(scope.agenda_calendar.selectionDates.settingEndDate){
            end.page = month_value-today_month+year_diff*12//isCurrent ? scope.agenda_calendar.pageCounter : scope.agenda_calendar.pageCounter+1;
            end.month_row = month_row;
            end.day = day;
            start_date_value = Number((start.page+1)+''+start.month_row+''+start.day);
            end_date_value = Number((end.page+1)+''+end.month_row+''+end.day);
            // $log.log('setting end date : ', end_date_value, month_value, today_month, year_diff)
            if(start_date_value >= end_date_value){
              start.page = end.page;
              start.month_row = end.month_row;
              start.day = end.day;
            }
          }else{
            start.page = month_value-today_month+year_diff*12//isCurrent ? scope.agenda_calendar.pageCounter : scope.agenda_calendar.pageCounter+1;
            start.month_row = month_row;
            start.day = day;
            start_date_value = Number((start.page+1)+''+start.month_row+''+start.day);
            end_date_value = Number((end.page+1)+''+end.month_row+''+end.day);
            // $log.log('setting start date : ', start, start_date_value)
            if(start_date_value >= end_date_value){
              end.page = start.page;
              end.month_row = start.month_row;
              end.day = start.day;
            }
            scope.agenda_calendar.selectionDates.settingEndDate = true;
          }
          // $log.log('selection date : ', scope.agenda_calendar.selectionDates)
        },
        getDatebasedStyle: function(month_row, day, isCurrent){
          var arr_to_check = isCurrent ? scope.agenda_calendar.currentMonthArray : scope.agenda_calendar.nextMonthArray;
          if((!arr_to_check[month_row*7+day] && arr_to_check[month_row*7+day] !== 0) || arr_to_check[month_row*7+day] === ""){
            return 'agendaDateCellRegular';
          }
          var month_value = isCurrent ? scope.agenda_calendar.currentMonth : scope.agenda_calendar.currentMonth+1;
          // var page_check =  isCurrent ? scope.agenda_calendar.pageCounter : scope.agenda_calendar.pageCounter+1;
          var start_date_value = getConvertedDate(scope.agenda_calendar.selectionDates.startDate, true)
          var end_date_value = getConvertedDate(scope.agenda_calendar.selectionDates.endDate)
          var checked_date_value = getDateVal(scope.agenda_calendar.currentYear , month_value, Number(arr_to_check[month_row*7+day]), false);

          var full_class = '';

          if(checked_date_value < getTodayDateConverted(true)){
            full_class = 'agendaDateCellRegularDisabled ';
          }
          if(isSameDate(start_date_value , checked_date_value)){
            full_class += 'agendaDateCellStartDate'
          }else if(isSameDate(end_date_value , checked_date_value)){
            full_class += 'agendaDateCellEndDate'
          }else if(start_date_value < checked_date_value && end_date_value > checked_date_value){
            full_class += 'agendaDateCellBetweenDate'
          }else{
            full_class += 'agendaDateCellRegular'
          }
          return full_class;
        },
        focusOnDate: function(isEndDate, to_today){
          // $log.log('focus on date : ' ,  scope.agenda_calendar)
          scope.agenda_calendar.selectionDates.settingEndDate = isEndDate;
          var page_diff = 0;
          if(to_today){
            page_diff = scope.agenda_calendar.pageCounter*-1
          }else{
            if(isEndDate){
              page_diff = (scope.agenda_calendar.selectionDates.endDate.page - scope.agenda_calendar.pageCounter);
            }else{
              page_diff = (scope.agenda_calendar.selectionDates.startDate.page - scope.agenda_calendar.pageCounter);
            }
          }
          while(page_diff !== 0){
            var dir =  page_diff > 0 ? 1 : -1;
            scope.agenda_calendar.shiftMonths(dir, true);
            page_diff += dir*-1;
          }
        },
        showArchiveConfirm: false,
        loadCurrentAgendaReport: function(){
          // $log.log('loadCurrentAgendaReport',scope.agenda_calendar.currentAgenda)
          scope.loadReport(scope.agenda_calendar.currentAgenda.id)
        },
        editCurrentAgenda: function(to_edit_mode){

          scope.new_agenda.reset();

          scope.new_agenda.inEditMode = to_edit_mode || false;
          scope.new_agenda.showAgendaModule = true;
          scope.new_agenda.description = scope.agenda_calendar.currentAgenda.description;
          // $log.log("current : , ", scope.agenda_calendar.currentAgenda)

          scope.new_agenda.unitResourcesList = scope.agenda_calendar.currentAgenda.resources;

          scope.new_agenda.isCustomUnit = true;
          scope.new_agenda.editingCustomUnit = true;
          scope.moduleMapData.resources.forEach(function(mod){
            if(mod.slug === scope.new_agenda.description){
              scope.new_agenda.isCustomUnit = false;
              scope.new_agenda.editingCustomUnit = false;
              scope.new_agenda.agenda_selected_module = mod.slug;
            }
          })
          scope.view_controller.showCustomUnits = scope.new_agenda.isCustomUnit;
          scope.new_agenda.agenda_selected_module_id = scope.agenda_calendar.currentAgenda.id;

          scope.students.list.forEach(function(student){
            if(!scope.agenda_calendar.currentAgenda.students || scope.agenda_calendar.currentAgenda.students.length === 0  || scope.agenda_calendar.currentAgenda.students.indexOf(student.user_id) > -1){
              student.selected = true;
            }else{
              student.selected = false;
            }
          })

          var date_diff;var date_diff2;
          if(to_edit_mode){
            scope.agenda_calendar.selectionDates.settingEndDate = false;
            var start_date = new Date(scope.agenda_calendar.currentAgenda.date_open);
            date_diff = getDateDiff(start_date);
            $log.log('to edit mode  : ' , start_date.getMonth(), scope.agenda_calendar.currentMonth)
            scope.agenda_calendar.setDateSelection(date_diff, start_date.getDay() , true, start_date.getMonth(), false, start_date.getFullYear());
            var end_date = new Date(scope.agenda_calendar.currentAgenda.date_close);
            date_diff2 = getDateDiff(end_date)
            scope.agenda_calendar.setDateSelection(date_diff2, end_date.getDay(), start_date.getMonth() === end_date.getMonth(), end_date.getMonth(), false, end_date.getFullYear());

            scope.agenda_calendar.checkAssessmentTypes();
          }

          scope.new_agenda.unlock_path = scope.agenda_calendar.currentAgenda.force_unlock;
          scope.agenda_student_selection.forceReattempt = scope.agenda_calendar.currentAgenda.force_redo;
          scope.new_agenda.editAgendaId = scope.agenda_calendar.currentAgenda.id;
        },
        uncheckDiagnosticFormative: function() {
            if (scope.new_agenda.agenda_selected_module.indexOf('run_like_math') > -1) {
              scope.new_agenda.module_checkbox_selections.diagnostic = false;
              scope.new_agenda.module_checkbox_selections.formative = true;
              scope.new_agenda.module_checkbox_selections.summative = false;
  
              scope.lastModuleType = "mathletic";
            }
            else if (scope.lastModuleType !== "regular") {
              scope.new_agenda.module_checkbox_selections.diagnostic = true;
              scope.new_agenda.module_checkbox_selections.formative = true;
              scope.new_agenda.module_checkbox_selections.summative = false;
  
              scope.lastModuleType = "regular";
            }
        },
        checkAssessmentTypes: function() {
          var hasDiagnostic = false;
          var hasSummative = false;
          var hasFormative = false;

          // $log.log("current agenda resources: " + scope.agenda_calendar.currentAgenda.resources);
          scope.agenda_calendar.currentAgenda.resources.forEach(function(resId){
            let item = getItemFromId(resId);

            if (item.config.assessment_type === "diagnostic") {
              hasDiagnostic = true;
            }
            else if (item.config.assessment_type === "summative") {
              hasSummative = true;
            }
            else {
              hasFormative = true;
            }
          });
          
          scope.new_agenda.module_checkbox_selections.diagnostic = hasDiagnostic;
          scope.new_agenda.module_checkbox_selections.summative = hasSummative;
          scope.new_agenda.module_checkbox_selections.formative = hasFormative;
        },
        getDateMonthDay: function(forStart){
          //$log.log('[[DATE TEST]]', scope.agenda_calendar.selectionDates)
          var date_use = scope.agenda_calendar.selectionDates.endDate;
          if(forStart){
            date_use = scope.agenda_calendar.selectionDates.startDate;
          }
          var get_date = new moment(getConvertedDate(date_use, forStart));
          // var day = dayRef[get_date.day()].toLowerCase();
          // return day.replace(day[0], day[0].toUpperCase()) + ' ' + monthRef[get_date.month()] + ' ' + get_date.date();
          return get_date;
        }
      }
      var agenda_calendar_default = angular.copy(scope.agenda_calendar);

      function getTodayDateConverted(usePageCount){
        var date_check = new Date();
        return date_check;
        // var date_val = usePageCount ? '1' : 1+date_check.getMonth()+'';
        // date_val += Math.floor((date_check.getDate()+date_check.getDay())/7)+''+date_check.getDay();
        // return Number(date_val);
      }

      function getDateDiff(date){
        // $log.log('date : ', date)
        var first_day_diff = angular.copy(date);
        first_day_diff.setDate(1);
        var diff = first_day_diff.getDay();
        return Math.floor((date.getDate()+diff-1)/7);
      }

      scope.agenda_calendar.selectionDates.settingEndDate = false;
      var date_diff = getDateDiff(current_date);
      scope.agenda_calendar.setDateSelection(date_diff, current_date.getDay(), true, current_date.getMonth());
      var date_plus_one_week = new Date();
      date_plus_one_week.setDate(date_plus_one_week.getDate()+7);
      var date_diff2 = getDateDiff(date_plus_one_week);
      scope.agenda_calendar.setDateSelection(date_diff2, date_plus_one_week.getDay(), current_date.getMonth() === date_plus_one_week.getMonth(), date_plus_one_week.getMonth());

      function getDayName(day, month, year){
        var totalDays = day + (2*month) + parseInt(3*(month+1)/5) + year + parseInt(year/4) - parseInt(year/100) + parseInt(year/400) + 2;
        // Mod of the total number of days with 7 gives us the day number
        var dayNo = (totalDays%7);
        // if the resultant mod of 7 is 0 then its Saturday so assign the dayNo to 7
        if(dayNo === 0){
              dayNo = 7;
        }
        return dayNo-1; // return the repective Day Name from the array
      }

      scope.agenda_student_selection = {
        tab_selection: 'class',
        switchTab: function(val){
          scope.agenda_student_selection.tab_selection = val;
          if(val === 'class'){
            scope.students.list.forEach(function(student){
              student.selected = true;
            })
          }else if(val === 'student'){
            scope.students.list.forEach(function(student){
              student.selected = false;
            })
          }
        },
        forceReattempt: true,
        reset: function(){
          scope.agenda_student_selection = {};
          scope.agenda_student_selection = angular.copy(agenda_student_selection_default);
        }
      }
      var agenda_student_selection_default = angular.copy(scope.agenda_student_selection);



      scope.agenda_filter = {
        showModal: false,
      }


      scope.agenda_archiver = {
        showArchived: false,
        toggleShowArchived: function(val){
            // $log.log('toggle show archive : ', val )
            scope.agenda_archiver.showArchived = val;
        },
        archiveCurrentAgenda: function(){
          // $log.log('archive this : ' , scope.agenda_calendar.currentAgenda)
          scope.archiveAgenda(scope.agenda_calendar.currentAgenda, true);
          scope.agenda_calendar.showArchiveConfirm = false;
        },
        restoreAgenda: function(agenda){
          // $log.log('unarchive this : ' , agenda)
          scope.archiveAgenda(agenda, false);
        }

      }

      scope.getFormattedFullDate = function(date){
        var date_parse = new Date(date);
        return date_parse.getFullYear() + '-' + monthRef[date_parse.getMonth()] + '-' + date_parse.getDate();
      }

      scope.getNumStudentsSelected = function(){
        var count = 0;
        try {
          _.each(scope.students.list, function(student){
            if (student && student.selected){
              count ++;
            }
          })
          return count;
        }
        catch(e){
          // $log.log('getNumStudentsSelected', count, scope.students.list)
          return 0
        }
      }

      var get_parent_slug = function(id_list){
        for(var x = id_list.length-1; x > -1; x--){
          var id = id_list[x];
          for(var i = 0; i < scope.moduleMapData.resources.length; i++){
            var mod = scope.moduleMapData.resources[i];
            for(var j = 0; j < mod.children.length; j++){
              var item = mod.children[j];
              if(item.id === id){
                return mod.slug;
              }
            }
          }
        }

      }
      scope.view_controller = {
        calendar_view: true,
        custom_unit_view: false,
        highlightedItem: null,
        customActivityVisible: false,
        showAgendaImportPanel: false,
        cached_items: [],
        toCustomView: function(applyCustomSelection, delay, setModuleSlug){
          var time = 0;
          if(delay){
            time = 200;
          }
          $timeout(function(){
            if(scope.new_agenda.editAgendaId){
              scope.view_controller.cached_items = [];
            }
            eventManager.broadcast('teacher:toggle:Sidepanel', false);
            scope.view_controller.calendar_view = false;
            scope.new_agenda.showAgendaModule = false;
            // $log.log('checking : ' , scope.new_agenda.editAgendaId)
            scope.new_agenda.description = setModuleSlug ? language.get(setModuleSlug) : (scope.new_agenda.description || scope.getTranslation('28844'));
            if(!scope.new_agenda.inEditMode || !scope.new_agenda.editingCustomUnit){
              // if (!scope.new_agenda.description){
              //   scope.new_agenda.description = scope.getTranslation('28844');
              // }
              scope.view_controller.highlightedItem = null;
            }
            scope.new_agenda.agenda_selected_module = '';
            if(applyCustomSelection){
              if(setModuleSlug){
                scope.view_controller.preticked_items = [];
                scope.moduleMapData.resources.forEach(function(mod){
                  if(mod.slug === setModuleSlug){
                    scope.modules.current = mod;
                    mod.children.forEach(function(item){
                      if (item){
                        if(item.config && item.config.assessment_type === "diagnostic"){
                          if(scope.new_agenda.module_checkbox_selections.diagnostic){
                            scope.view_controller.preticked_items.push(item.id);
                          }
                        }else if(item.config && item.config.assessment_type === "summative"){
                          if(scope.new_agenda.module_checkbox_selections.summative){
                            scope.view_controller.preticked_items.push(item.id);
                          }
                        }else if(scope.new_agenda.module_checkbox_selections.formative && (item.resource_type === "lesson" || item.config.assessment_type === "formative")){
                          scope.view_controller.preticked_items.push(item.id);
                        }
                      }
                    })
                  }
                })
                // $timeout(function(){
                //   eventManager.broadcast('tick:module', setModuleSlug)
                // }, 500)
              }else{
                scope.view_controller.preticked_items = (scope.new_agenda.unitResourcesList);
                var parent_slug = get_parent_slug(scope.view_controller.preticked_items);
                //if(parent_slug && parent_slug.indexOf('run_like_math') === -1){
                  scope.view_controller.openSubMod(parent_slug);
                //}
              }

              // $log.log('apply ticks : ', scope.view_controller.preticked_items)

            }
            scope.view_controller.custom_unit_view = true;

            if(scope.custom_units_list.length > 0 && !scope.custom_units_list[0].id){
              scope.custom_units_list.splice(0,1);
            }
          }, time)
        },
        toCalendarView: function(keepPopup, keep_temp){
          scope.isMeta = true;
          var temp = scope.new_agenda.agenda_selected_module_id;
          scope.resetAgendaModalState(true)
          scope.view_controller.custom_unit_view = false;
          scope.view_controller.calendar_view = true;
          scope.new_agenda.showAgendaModule = keepPopup || false;
          scope.view_controller.preticked_items = null;
          scope.new_agenda.confirmWizardClose = true;
          if(keep_temp){
            scope.new_agenda.agenda_selected_module_id = temp;
          }
        },
        save_resources_continue: function(){
          var resources = scope.view_controller.getSelectedItems();
          scope.view_controller.cached_items = resources
          // $log.log('save resource continue  : ', resources)
          var resources_id = [];
          resources.forEach(function(item){
            if((item.type === 'custom_resource' || item.resource_type === 'custom_resource') && item.slug){
              resources_id.push(item.id ? item.id : item.slug);
              scope.custom_module_controller.list.push(item);
            }else{
              if(item.id && resources_id.indexOf(item.id) === -1){
                resources_id.push(item.id);
              }else{
                var slug_id = getItemFromSlug(item.slug)
                if(slug_id){
                  resources_id.push(slug_id.id);
                }
              }
            }
          })
          if(resources_id.length === 0){
            window.alert(language.get('22947'));
            return;
          }
          //scope.new_agenda.move_page(1);
          scope.new_agenda.isCustomUnit = true;
          scope.new_agenda.editingCustomUnit = true;
          scope.new_agenda.unitResourcesList = resources_id;
          scope.new_agenda.showAgendaModule = true;
          scope.view_controller.custom_unit_view = false;
          scope.view_controller.calendar_view = true;
          scope.view_controller.showCustomUnits = true;

          if(scope.new_agenda.editAgendaId && scope.new_agenda.inEditMode){
            createNewAgendaV2(true);
          }else{
            scope.custom_units_list.splice(0,0, {description: scope.new_agenda.description, resources: resources_id})
          }
        },
        showCustomDraggable: false,
        openSubMod: function(slug){
          // $log.log('open sub mod : ' , slug)
          scope.isMeta = false;
          $timeout(function(){
            eventManager.broadcast('module:change:submodule', slug);
            // eventManager.broadcast('retrigger-workspace-filters', slug);
          }, 1000)
        },
        openMainMod: function(slug){
          scope.isMeta = true;
          scope.view_controller.highlightedItem = null;
          eventManager.broadcast('module:change:meta', slug);
        },
        reset: function(){
          scope.view_controller = {};
          scope.view_controller = angular.copy(view_controller_default);
        },
        copyItemLink: function(item){
          scope.copyItemLink()
        }
      }
      var view_controller_default = angular.copy(scope.view_controller);

      eventManager.listen('module:change:meta', ()=>{   
        scope.isMeta = true;     
        scope.view_controller.highlightedItem = null;
      })

      function getItemFromSlug(slug){
        for(var i = 0; i <  scope.moduleMapData.resources.length; i++){
          for(var j = 0; j <  scope.moduleMapData.resources[i].children.length; j++){
            var item =  scope.moduleMapData.resources[i].children[j]

            if(item.slug === slug){
              return item;
            }
          }
        }
      }

      function getItemFromId(id){
        for(var i = 0; i <  scope.moduleMapData.resources.length; i++){
          for(var j = 0; j <  scope.moduleMapData.resources[i].children.length; j++){
            var item =  scope.moduleMapData.resources[i].children[j]

            if(item.id === id){
              return item;
            }
          }
        }
      }

      scope.custom_module_controller = {
        current:[{}],
        list:[],
        toTitleEdit: function(){
          scope.custom_module_controller.editTitle = true;
          // document.getElementById('custom_activity_box').addEventListener('pointerdown', endTitleEdit)
        },
        content:'',
        title: '', // custom module title
        editTitle: false,
        uncheckedBoxClick: function() {
          window.alert(scope.getTranslation('27735')) //'You must click the check box to proceed.'
        },
        createCustomUnit: function(){
          var slug = [
            _.toArray(this.custom).length ,
            String(Date.now()) ,
            Math.random().toString(36).substr(3,7)
          ].join('_');
          if(!isValidURL(scope.custom_module_controller.content)) {
            window.alert(scope.getTranslation('27689')) // please enter a valid url
          }else{
            // scope.custom_module_controller.current = [];
            scope.custom_module_controller.current.push({
              type: 'custom_resource',
              name: scope.custom_module_controller.title || 'custom_resource',
              slug: slug,
              content: {
                value: scope.custom_module_controller.content,
                container: 'link'
              },
              show: true,
              is_selected: true
            })
            // $log.log('CREATING CUSTOM UNIT :  ', scope.custom_module_controller.current)

            scope.view_controller.showCustomDraggable = true;
            scope.view_controller.customActivityVisible = false;
          }
        },
        reset: function(){
          scope.custom_module_controller = {};
          scope.custom_module_controller = angular.copy(custom_module_controller_default);
        }
      }
      var custom_module_controller_default = angular.copy(scope.custom_module_controller);

      scope.getModuleIconAssetUrl = function(item){
        if(scope.moduleMapData && scope.moduleMapData.meta_config && scope.moduleMapData.meta_config.map_config && scope.moduleMapData.meta_config.map_config.set_module_icon_names){
          var asset_name = scope.moduleMapData.meta_config.map_config.set_module_icon_names[item.slug] || scope.moduleMapData.meta_config.map_config.set_module_icon_names.default;
          return scope.moduleMapData.meta_config.map_config.asset_url + asset_name + ".png";
        }
        if(item.config.map_config && item.config.map_config.asset_url){
          return item.config.map_config.asset_url+item.slug+'.png';
        }
        return PanelFactory.getModuleIconAssetUrl(item.slug, null, item.parent_resource_id);
      }


      var last_image_url = ''
      scope.getCurrentItemImg = function(){
        if(!scope.view_controller.highlightedItem){
          return;
        }
        var item = getItemFromSlug(scope.view_controller.highlightedItem.slug);
        if(!item){
          return;
        }
        if (item !== lastItemImage){
          lastItemImage = item;
          scope.shown_img_index = 0;
        }
        // $log.log('view_controller.highlightedItem : ', item, scope.view_controller.highlightedItem);
        var cur_img = PanelFactory.getItemImage(item)      
        return cur_img;
      }

      scope.getSelectedItemUrl = function(override_item){
        let item_to_use = override_item || scope.view_controller.highlightedItem;
        let item =  getItemFromSlug(item_to_use.slug);
        if(!item_to_use || !scope.modules.list || item.config.assessment_type === "summative"){
          return '';
        }
        var location_host = window.location.host;
        if(location_host.indexOf('mathematic.org') > -1 || location_host.indexOf('mathematic.lu') > -1){
          location_host+='/app2'
        }
        return window.location.href.split('://')[0]+'://'+location_host+'/#open_item_link=true&module_id='+scope.modules.list[0].parent_resource_id+'&item_id='+getItemFromSlug(item_to_use.slug).id
      }

      
      scope.togglCollapseSideView = function(){
        scope.collapseSideView = !scope.collapseSideView;
        eventManager.broadcast('triggerMapResize')
      }

      scope.showCollapseIcon = window.innerWidth < 1225
      window.addEventListener("resize", function(){
          scope.showCollapseIcon = window.innerWidth < 1225
          if(window.innerWidth >= 1225){
            scope.collapseSideView = false;            
          }
      });

      scope.openItemListLink = function(){
        scope.url_list = []
        _.each(scope.view_controller.getSelectedItems(), function(item){
          let item_url =  scope.getSelectedItemUrl(item);
          if(item_url){
            scope.url_list.push({name: item.slug, url: item_url });
          }
        })
        scope.hideItemLinkListTable = false;
        $timeout(()=>{  
          scope.showItemLinkListTable = true;        
        }, 200)
      }

      scope.openItemLink = function(url){
        if (PlatformService.isApp){
          cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: url });
        }else{          
          window.open(url,'_blank');
        }
      }

      scope.copyItemLink = function(){        
        if (!navigator.clipboard) {
          //edge and ie support
          var textArea = document.createElement("textarea");
          textArea.value = scope.getSelectedItemUrl();
          textArea.style.position="fixed"; 
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          return;
        }
        navigator.clipboard.writeText(scope.getSelectedItemUrl());
      }

      scope.downloadLinksAsPdf = function(){
        var filename = 'item_links_'+moment().format('YYYYMMDD')+'.csv';
        var file_text = 'sep=;\n'+language.get('item_links_item_name')+';'+language.get('item_links_link_url')+'\r\n';
        _.each(scope.url_list, function(item){
          let item_name = language.get(item.name);
          file_text +=  '"' + item_name.split(';').join('\;')+ '"' + ';' + item.url + '\r\n';
        })    

        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(file_text));
        element.setAttribute('download', filename);
      
        element.style.display = 'none';
        document.body.appendChild(element);
      
        element.click();
      
        document.body.removeChild(element);
      }

      scope.hideItemLinkListTable = true;
      scope.hideItemsList = function(){
        scope.showItemLinkListTable = false;
        $timeout(()=>{          
          scope.hideItemLinkListTable = true;
        }, 200)
      }
      eventManager.listen('module:select:resource', function(e, item){
        if(scope.showItemLinkListTable){
          scope.openItemListLink();
        }
      })

      scope.$watch('view_controller.highlightedItem', function(val, old){
        scope.shown_img_index = 0;
        if(val){
          var agendaImgBox = document.getElementById('agendaImgBox')     
          // if(agendaImgBox){       
          //   var _canvasEl = document.getElementById('module-item-map-canvas')
          //   var middleview = document.getElementById('agenda_middleview')
          //   agendaImgBox.style.top = _canvasEl.height/2 - agendaImgBox.offsetHeight/2 - 380 + 'px'
          //   agendaImgBox.style.left = _canvasEl.width/2 - agendaImgBox.offsetWidth/2 + middleview.offsetWidth - 120 + 'px'
          // }
        }else{
          eventManager.broadcast('hide_item_selection_highlight', old)
        }
      })
     
      scope.changeImgIndex = function(index){
        scope.shown_img_index = index;
      }

      scope.treeOptions = {
        dragStart: function(evt, smth){
          // $log.log('DRAGGING START:  ', evt, smth)
          scope.isDragging = true;
        },
        dragStop: function(){
          // $log.log('DRAGGING STOP:  ')
          scope.isDragging = false
        }
      }

      eventManager.listen('request_agenda_change', function(e, option){
        // $log.log('got agenda change request : ', option)
        if(scope.new_agenda.showAgendaModule || scope.view_controller.custom_unit_view){
          scope.show_close_warning = true;
          scope.navigate_from_agenda_warning = true;
          scope.agenda_nav_move = true;
          scope.saved_nav_option = option;
        }else{
          if(option.class_change){
            eventManager.broadcast('agenda_class_change_request_granted', option.class_id);
            return;
          }else if(option.goto_myclass){
            eventManager.broadcast('agenda_myclasses_change_request_granted', null);
          }
          eventManager.broadcast('agenda_change_request_granted', option);
        }
      });

      eventManager.listen('module:change:metaToSub', function(e, data) {
        if(!data.parent_resource_id){
          var item = getItemFromSlug(data.slug);
          data.parent_resource_id = item.parent_resource_id;
        }
        var mod;
        for(var i = 0; i <  scope.moduleMapData.resources.length; i++){
            if(scope.moduleMapData.resources[i].id === data.parent_resource_id){
              mod = scope.moduleMapData.resources[i];
              break;
            }
        }
        scope.modules.current = mod;
        $timeout(function(){
          eventManager.broadcast('module:select:resource', data);
        }, 500)
      })

      eventManager.listen('retrigger-workspace-filters', function(e, args){
        scope.modules.current = null;
        $timeout(function(){
          // if(args==="run_like_math"){
          //   scope.moduleMapData.resources.forEach( function(mod){
          //     if(mod.slug === args){
          //       scope.modules.current = mod;
          //     }
          //   });
          // }else{
            scope.modules.list.forEach( function(mod){
              if(mod.slug === args){
                scope.modules.current = mod;
              }
            });
         // }
        }, 50)
      });
      eventManager.listen('module:change:run_like_math', function(e, mod) {
        // $log.log('here !')
        $timeout(function(){
          scope.modules.current = mod;
        },100);
      });

      scope.triggerAgendaSelection = function(slug){
        eventManager.broadcast('toggle_item_selection_highlight', slug);
      }
      scope.filtered_get = function(slug){
        if(slug === 'run_like_math' || slug.indexOf('run_like_math') === -1 || slug.indexOf('lv_') === -1){
          return language.get(slug)
        }else{
          var splt = slug.split('_');
          var level = '';
          if(!isNaN(splt[splt.length-1])){
            level = splt[splt.length-1];
          }
          var trans_slug = slug.replace('_'+level, '');
          //run_like_math_obj[trans_slug][language.getCurrentSelectedLanguage()]
          return language.get(trans_slug)+ ' ' + level;
        }
      }
      scope.agendaImporter = {
        agendaImportCode: '',
        importAgenda: function(){
          var regex = /^[0-9]*\-[0-9]+$/
          var matches = scope.agendaImporter.agendaImportCode.match(regex)
          if(!matches){
            window.alert(scope.getTranslation('enter_valid_code'))
            return;
          }
          var agenda_code = scope.agendaImporter.agendaImportCode.split('-')[1];
          for(var i = 0; i < scope.agendas.list.length; i++){
            if(scope.agendas.list[i].id+'' === agenda_code){
              window.alert('Agenda already exists')
              return;
            }
          }

          // $log.log('importing : ' , scope.agendaImporter.agendaImportCode )
          TeacherDataService.importAgenda(scope.currentClassId , scope.agendaImporter.agendaImportCode)
          .then(function(agenda){
            // $log.log('imported agenda : ' , agenda)
            eventManager.broadcast('teacherStudentsAgenda:refresh', true);
          })
          .catch(function(err){
            $log.log('ERROR IMPORTING : ', err);
            window.alert('There was an error, could not import agenda')
          })
        }
      }

      scope.sendLabelClick = function(e, id){
        if(PlatformService.isIos){
          var elm = document.getElementById(id);
          if(elm){
            elm.click();
          }
        }
      }
    }
  }
});

